/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DataEntryLinkRepresentationFromJSON(json) {
    return DataEntryLinkRepresentationFromJSONTyped(json, false);
}
export function DataEntryLinkRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        key: json['key'],
        issuerId: json['issuerId'],
        path: json['path'],
        versionIds: json['versionIds'],
        filterTagIds: json['filterTagIds'],
        intervalStart: new Date(json['intervalStart']),
        intervalEnd: new Date(json['intervalEnd']),
        creationTime: new Date(json['creationTime']),
        expirationTime: new Date(json['expirationTime']),
        duration: json['duration'],
    };
}
export function DataEntryLinkRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        key: value.key,
        issuerId: value.issuerId,
        path: value.path,
        versionIds: value.versionIds,
        filterTagIds: value.filterTagIds,
        intervalStart: value.intervalStart.toISOString().substr(0, 10),
        intervalEnd: value.intervalEnd.toISOString().substr(0, 10),
        creationTime: value.creationTime.toISOString(),
        expirationTime: value.expirationTime.toISOString(),
        duration: value.duration,
    };
}
